import styled from "styled-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { StyledWizardAnimationWrapper } from "../../styles";

const WIZARD_TITLE_LINE_HEIGHT = 40;
const WIZARD_DESCRIPTION_LINE_HEIGHT = 24;
const WIZARD_DESCRIPTION_MARGIN_TOP = 8;
const WIZARD_DESCRIPTION_MARGIN_BOTTOM = 28;

const WIZARD_CONTENT_HEADER_HEIGHT = WIZARD_TITLE_LINE_HEIGHT + WIZARD_DESCRIPTION_LINE_HEIGHT + WIZARD_DESCRIPTION_MARGIN_TOP + WIZARD_DESCRIPTION_MARGIN_BOTTOM;

export const WIZARD_CONTENT_SIDE_PADDING = 97;

export const StyledWizardContentContainer = styled(StyledWizardAnimationWrapper)`
    padding: 94px ${WIZARD_CONTENT_SIDE_PADDING}px 0 ${WIZARD_CONTENT_SIDE_PADDING}px;
    position: relative;
    height: calc(100% - 94px);
    max-height: calc(100% - 94px);

    display: flex;
    flex-direction: column;

    @media (max-width: 1280px) {
        padding-top: 90px;
        height: calc(100% - 90px);
        max-height: calc(100% - 90px);
    }
`;

export const StyledScrollableContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    height: calc(100% - ${WIZARD_CONTENT_HEADER_HEIGHT}px);
`;
export const StyledWizardFooterWrapper = styled.div`
    flex-grow: 1;
    padding: 8px 0 30px;
`;

export const StyledWizardQuestionTitle = styled.div<{ delay?: number }>`
    ${setFontVariant("h2", colorsPalettes.carbon[500])};
    font-size: 38px;
    line-height: ${WIZARD_TITLE_LINE_HEIGHT}px;

    opacity: 0;
    animation: wizard-animation-item 600ms forwards ${({ delay }) => `${delay || 0}s`};
    
    @media (max-width: 1280px) {
        font-size: 30px;
    }
`;
export const StyledWizardQuestionDescription = styled.div`
    margin-top: ${WIZARD_DESCRIPTION_MARGIN_TOP}px;
    margin-bottom: ${WIZARD_DESCRIPTION_MARGIN_BOTTOM}px;
    ${setFontVariant("h6", colorsPalettes.carbon[300])};
    font-size: 22px;
    font-weight: 400;
    line-height: ${WIZARD_DESCRIPTION_LINE_HEIGHT}px;

    @media (max-width: 1280px) {
        font-size: 18px;
    }
`;

